import { selectCurrentRoles } from "features/auth/authSlice";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CardHeader, Col, Input, Label, Row, Button } from "reactstrap";
import swal from "sweetalert";
import { useSaathiAprrovalbyIdMutation } from "./SaathiApiSlice";

const SaathiCheckerMaker = ({ SaathiDetail }) => {
  const { id } = useParams();
  const [remarks, setRemarks] = useState("");

  const handleRemarks = (event) => {
    // console.log("event", event.target.value);
    setRemarks(event.target.value);
  };

  const RolesFromToken = useSelector(selectCurrentRoles);
  var Maker = RolesFromToken.groups.includes("Maker");
  var Checker = RolesFromToken?.groups.includes("Checker");

  const [updateSaathi, refetch] = useSaathiAprrovalbyIdMutation();

  const handleApprove = () => {
    const action = Maker ? "qc1_approved" : Checker ? "qc2_approved" : "";
    const approval = { action: action, qc_remark: remarks };

    if (remarks === "") {
      swal("Remarks is mendatory !!", {
        buttons: false,
        icon: "warning",
        title: "Please Enter Remark",
        timer: 1500,
      });
    } else {
      let ApplicantId = id;
      updateSaathi({ ApplicantId, approval })
        .then((response) => {
          if (response.data) {
            swal("Success", {
              buttons: false,
              icon: "success",
              title: response.data.message,
              timer: 1500,
            });
            setRemarks("");
            refetch();
          } else if (response.error) {
            swal("Error", {
              buttons: false,
              icon: "warning",
              title: response.error.data.message,
              timer: 3000,
            });
          }
        })
        .catch((error) => {
          console.log("catch", error);
        });
    }
  };

  const handleReject = () => {
    const action = Maker ? "qc1_rejected" : Checker ? "qc2_rejected" : "";
    const approval = { action: action, qc_remark: remarks };

    if (remarks === "") {
      swal("Remarks is mendatory !!", {
        buttons: false,
        icon: "warning",
        title: "Please Enter Remark",
        timer: 1500,
      });
    } else {
      let ApplicantId = id;
      updateSaathi({ ApplicantId, approval })
        .then((response) => {
          if (response.data) {
            swal("Success", {
              buttons: false,
              icon: "success",
              title: response.data.message,
              timer: 1500,
            });
            setRemarks("");
          } else if (response.error) {
            swal("Error", {
              buttons: false,
              icon: "warning",
              title: response.error.data.message,
              timer: 3000,
            });
          }
        })
        .catch((error) => {
          console.log("catch", error);
        });
    }
  };

  return (
    <div>
      {Maker ? (
        <Row>
          <Col className="col-lg-12 my-4">
            <CardHeader style={{ padding: "13px" }}>
              <h5 className="m-0">
                {SaathiDetail === "QC1 Approved"
                  ? "Already Approved"
                  : "Take Action"}{" "}
              </h5>
            </CardHeader>
            {SaathiDetail === "QC1 Approved" ? (
              ""
            ) : (
              <form className="needs-validation mt-3">
                <Col lg="12" className="mb-2">
                  <Label>Remarks *</Label>

                  <Input
                    style={{ fontSize: "16px" }}
                    type="textarea"
                    id="textarea"
                    name="remarks"
                    placeholder="Please Enter Remark"
                    onChange={handleRemarks}
                    value={remarks}
                    required
                  />
                </Col>

                <Col className="text-center mt-3">
                  <button
                    id="approval"
                    type="button"
                    className="btn btn-success waves-effect me-2 "
                    onClick={() => handleApprove()}
                    disabled={
                      SaathiDetail === "QC1 Approved" &&
                      RolesFromToken.groups.includes("Maker")
                        ? true
                        : false
                    }
                  >
                    Approve <span className="mdi mdi-check-all "></span>
                  </button>
                  <Button
                    id="rejected"
                    type="button"
                    className="btn btn-danger waves-effect me-2"
                    onClick={() => handleReject()}
                    disabled={
                      SaathiDetail === "QC1 Approved" &&
                      RolesFromToken.groups.includes("Maker")
                        ? true
                        : false
                    }
                  >
                    Reject <span className="mdi mdi-window-close fs-"></span>
                  </Button>
                </Col>
              </form>
            )}
          </Col>
        </Row>
      ) : (
        ""
      )}
    </div>
  );
};

export default SaathiCheckerMaker;
